import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { VoucherCodeTest } from './VoucherCodeTest';
import { Four04 } from 'gossamer-front-end';

export const VoucherCodesRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/test" element={<VoucherCodeTest />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
